import {
	BrowserRouter as Router,
	Switch,
	Route,
} from 'react-router-dom';

import {MainContextProvider} from 'mainContext'

import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Home from 'views/Index';
import Search from 'views/Search';
import Collection from 'views/Collection';
import Player from 'components/Player'

function App() {

	return (
		<MainContextProvider>
			<Router>
				<div className="flex flex-col h-full">
					<div className="calc-h-full-22 flex">
						<Sidebar/>
						<main
							className="main-container flex-1 overflow-auto relative py-15 px-8 z-[1] bg-white bg-opacity-[0.08]">
							<Header/>
							<Switch>
								<Route path="/search">
									<Search/>
								</Route>
								<Route path="/collection">
									<Collection/>
								</Route>
								<Route path="/">
									<Home/>
								</Route>
							</Switch>
						</main>
					</div>
					<div className="relative">
						<Player/>
					</div>
				</div>
			</Router>
		</MainContextProvider>
	);
}

export default App;
